export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.18-1640.02",
  commitId: "5b601d75570222ed3dc2d7e4183f79733d9bdffb",
  commitTime: "2026-05-18T16:40:02.000Z",
});
